import React from 'react';
import { Image } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import { backgroundThemeState, enterState } from '../../../../../atoms';
import { useAnimationForBackGround } from '../../../../../util/hooks';

export interface BackgroundImageProps {
  enter?: boolean;
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
}

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
  enter,
  className,
  style,
  width = '100%',
  height = '100%',
}) => {
  const background = useRecoilValue(backgroundThemeState);
  const access = useRecoilValue(enterState);

  useAnimationForBackGround(enter!, access, className!);

  return (
    <Image
      className={className}
      src={background}
      width={width}
      height={height}
      style={style}
    />
  );
};
